module.exports = __webpack_public_path__ + "static/media/play-icon.a8dc9202.svg";